var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.c550e3abd9617115e6409c15d378c1810d6cf76d8ce328c4a1e2f0c747e6f5b2.svg#video-player-icon';
                    var viewUrl = 'sprite.c550e3abd9617115e6409c15d378c1810d6cf76d8ce328c4a1e2f0c747e6f5b2.svg#view-video-player-icon';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };